/**
 * Interface chrome — navigation, form labels, controls. Distinct from the
 * editorial copy in `content/`, which the backend serves and a non-developer
 * may edit; these strings only change when the interface itself changes.
 */
export interface Messages {
  skipToContent: string;
  nav: {
    label: string;
    services: string;
    how: string;
    work: string;
    contact: string;
    openMenu: string;
    closeMenu: string;
  };
  form: {
    name: string;
    email: string;
    company: string;
    message: string;
    messagePlaceholder: string;
    honeypot: string;
    submit: string;
    submitting: string;
    sentTitle: string;
    sendAnother: string;
    networkError: (phone: string) => string;
  };
  channels: {
    phone: string;
    where: string;
    whereHint: string;
  };
  footer: { registryCode: string; backToTop: string };
}

export const t: Messages = {
  skipToContent: 'Skip to content',
  nav: {
    label: 'Main',
    services: 'Services',
    how: 'How we work',
    work: 'Work',
    contact: 'Contact',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  form: {
    name: 'Your name',
    email: 'Email',
    company: 'Company (optional)',
    message: 'What do you need built, or fixed?',
    messagePlaceholder: 'A couple of sentences is plenty to start.',
    honeypot: 'Leave this empty',
    submit: 'Send message',
    submitting: 'Sending…',
    sentTitle: 'Message sent',
    sendAnother: 'Send another message',
    networkError: (phone) => `Could not reach us just now. Call ${phone} instead.`,
  },
  channels: {
    phone: 'Phone',
    where: 'Where',
    whereHint: 'Working remotely across the EU',
  },
  footer: {
    registryCode: 'Registry code',
    backToTop: 'Back to top',
  },
};
